module.exports = __webpack_public_path__ + "static/media/market_events.3c836b4f.svg";